import React from 'react';
import EmployeeCaseVerticalPage from '../People/EmployeeCaseVerticalPage';

export default function EmployeeCasePage(){
  return <EmployeeCaseVerticalPage />;
}

